import * as amplitude from '@amplitude/analytics-browser';
import axios from 'axios';

// Utils.
import { isIOSApp, isAndroidApp } from 'utils';

// Configs.
import  { amplitudeApiKey, welltoryAnalyticsURL } from '../config';

const getDayOfWeek = () => {
  const date = new Date();
  const dayOfWeek = date.toLocaleString('en-us', {  weekday: 'long' }).toLowerCase();
  return dayOfWeek;
};
const getPartOfDay = () => {
  const date = new Date();
  const hours = date.getHours();
  let partOfDay = '';
  if (hours >= 3 && hours < 5) {
    partOfDay = 'night';
  }
  if (hours >= 5 && hours < 12) {
    partOfDay = 'morning';
  }
  else if (hours >= 12 && hours < 20) {
    partOfDay = 'day';
  }
  else if (hours >= 20 && hours < 3) {
    partOfDay = 'evening';
  }
  return partOfDay;
};

const welltoryAnaliticsEvent = (eventId, eventProperties) => {
  if (window.welltoryAnalitics === undefined) {
    return;
  }
  const { profile, config } = window.welltoryAnalitics;
  if (config.analytics_send_to_welltory !== true) {
    return;
  }
  const data = {
    event_id: eventId,
    user_id: profile.id,
    device_id: `${profile.id}`,
    date_created: new Date().toISOString(),
  };
  if (eventProperties !== undefined) {
    data.event_props = eventProperties;
  }
  axios({
    method: 'POST',
    baseURL: welltoryAnalyticsURL,
    url: '/api/v1/send',
    data: data,
    withCredentials: false,
    headers: {
      'X-authorization': config.welltory_analytics_token,
    }
  })
};

const analyticsActionEvent = (event, properties = {}) => {
  if (event === undefined) {
    return;
  }
  if (!amplitude.getUserId()) {
    return;
  }
  const eventProperties = { ...properties };
  eventProperties.day_time = getPartOfDay();
  eventProperties.week_day = getDayOfWeek();

  if (typeof window.FB?.AppEvents?.logEvent === 'function') {
    window.FB.AppEvents.logEvent(event, null, eventProperties);
  }
  welltoryAnaliticsEvent(event, eventProperties);
  return amplitude.track(event, eventProperties);
};

export function identifyUser(profile = {}) {
  let os;
  if (isIOSApp()) {
    os = 'iOS';
  }
  else if (isAndroidApp()) {
    os = 'Android';
  }
  else {
    os = 'Web';
  }
  if (profile.id !== undefined) {
    amplitude.setUserId(profile.id);
  }
  amplitude.init(amplitudeApiKey, null, { 'platform': os });
  return;
}

export function identifyUserFB(profile) {
  if (typeof window.FB?.AppEvents?.setUserID === 'function') {
    window.FB.AppEvents.setUserID(`${profile.id}`);
  }
  return;
}

export function resetUser() {
  if (window.FB) {
    window.FB.AppEvents.clearUserID();
  }
  return amplitude.reset();
}

export function clickGetAppButton(store) {
  const eventProperties = {
    store: store,
  };
  analyticsActionEvent('GetApp_Button_Clicked_Web', eventProperties);
}

export function openLoginRegisterPage() {
  analyticsActionEvent('OnbScr_RegScr_Viewed');
}

export function signupEmail() {
  analyticsActionEvent('Signup_email');
}

export function login(screen, method) {
  const eventProperties = {
    screen: screen,
    method: method,
  };
  analyticsActionEvent('Login', eventProperties);
}

export function viewResetPasswordButton() {
  analyticsActionEvent('ForgotPasswordScr_Viewed');
}

export function showMessageResetPasswordButton() {
  analyticsActionEvent('Popup_SentPassword_Received');
}

export function clickDownloadStoreButton(store) {
  const eventProperties = {
    store: store,
  };
  analyticsActionEvent('GetApp_Button_Clicked_Web', eventProperties);
}

export function openDashboardPage(isDemo) {
  const eventProperties = {
    is_demo: isDemo,
  };
  analyticsActionEvent('MyData_Viewed', eventProperties);
}

export function viewChartModal(isDemo) {
  const eventProperties = {
    is_demo: isDemo,
  };
  analyticsActionEvent('Chart_Viewed_Web', eventProperties);
}

export function clickExportChartButton(isDemo) {
  const eventProperties = {
    is_demo: isDemo,
  };
  analyticsActionEvent('Chart_Export_Clicked_Web', eventProperties);
}

export function clickRRIntervalsChartButton(isDemo) {
  const eventProperties = {
    is_demo: isDemo,
  };
  analyticsActionEvent('Chart_RRintervals_Clicked_Web', eventProperties);
}

export function clickDataSourcesCategory(category) {
  const eventProperties = {
    source_category: category,
  };
  analyticsActionEvent('SourcesScr_SourceType_Clicked', eventProperties);
}

export function clickDataSource(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('SourcesScr_Source_Clicked', eventProperties);
}

export function clickDataSourceConnect(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_ButtonConnect_Clicked', eventProperties);
}

export function clickDataSourceAffiliateButton(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_ButtonAffiliate_Clicked', eventProperties);
}

export function clickDataSourceAppleHealthClicked(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_ButtonAppleHealth_Clicked', eventProperties);
}

export function clickDataSourceGoogleFitClicked(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_ButtonGoogleFit_Clicked', eventProperties);
}

export function clickDataSourceDisconnect(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_ButtonDisconnect_Clicked', eventProperties);
}

export function clickDataSourceConnectOpenGetAccessModal(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_PopupGetAccess_Opened', eventProperties);
}

export function clickDataSourceConnectClickPaymentGetAccessModal() {
  const eventProperties = {
    screen: 'datasources',
  };
  analyticsActionEvent('Upgrade_Button_Clicked', eventProperties);
}

export function clickDataSourceConnectCloseGetAccessModal(category, source) {
  const eventProperties = {
    source_category: category,
    source_name: source,
  };
  analyticsActionEvent('OneSourceScr_PopupGetAccess_Closed', eventProperties);
}

export function clickLMSClickPaymentGetAccess() {
  const eventProperties = {
    screen: 'academy',
  };
  analyticsActionEvent('Upgrade_Button_Clicked', eventProperties);
}

export function viewLMSAcademy(lmsCourse) {
  analyticsActionEvent('Academy_Viewed_Web');
}

export function clickLMSCourse(lmsCourse) {
  const eventProperties = {
    course_title: lmsCourse.title,
  };
  analyticsActionEvent('AcademyScr_Course_Clicked', eventProperties);
}

export function viewLMSCourse(lmsCourse) {
  const eventProperties = {
    course_title: lmsCourse.title,
    course_slug: lmsCourse.slug,
  };
  analyticsActionEvent('Courses_Viewed_Web', eventProperties);
}

export function clickLMSMaterial(lmsMaterial, lmsCourse) {
  const eventProperties = {
    material_id: lmsMaterial.id,
    course_title: lmsCourse.title,
  };
  analyticsActionEvent('AcademyScr_Material_Clicked', eventProperties);
}

export function viewedLMSMaterial(lmsMaterial, lmsCourse) {
  const eventProperties = {
    material_id: lmsMaterial.id,
    material_name: lmsMaterial.title,
    course_title: lmsCourse.title,
    course_slug: lmsCourse.slug,
  };
  analyticsActionEvent('AcademyScr_Material_Viewed', eventProperties);
}

export function clickLMSMaterialDone(lmsMaterial, lmsCourse) {
  const eventProperties = {
    material_id: lmsMaterial.id,
    material_name: lmsMaterial.title,
    course_title: lmsCourse.title,
    course_slug: lmsCourse.slug,
  };
  analyticsActionEvent('AcademyScr_Material_Done', eventProperties);
}

export function clickLMSCourseGetAccess(lmsCourse) {
  const eventProperties = {
    course_title: lmsCourse.title,
  };
  analyticsActionEvent('AcademyScr_CourseGetAccess_Clicked', eventProperties);
}

export function clickLMSMaterialGetAccess(lmsMaterial, lmsCourse) {
  const eventProperties = {
    material_id: lmsMaterial.id,
    course_title: lmsCourse.title,
  };
  analyticsActionEvent('AcademyScr_MaterialGetAccess_Clicked', eventProperties);
}

export function clickDashboardConnect() {
  analyticsActionEvent('DashboardScr_ButtonConnect_Clicked');
}

export function clickDashboardUpgrade() {
  const eventProperties = {
    screen: 'dashboard',
  };
  analyticsActionEvent('Upgrade_Button_Clicked', eventProperties);
}

export function clickDashboardConnectSource() {
  analyticsActionEvent('DashboardScr_ButtonConnectSourсe_Clicked');
}

export function clickDashboardShare() {
  analyticsActionEvent('DashboardScr_ButtonShare_Clicked');
}

export function clickDashboardExportCSV(type) {
  const eventProperties = {
    type: type,
  };
  analyticsActionEvent('DashboardScr_ExportCSV_Done', eventProperties);
}

export function clickDashboardPeriodChange() {
  analyticsActionEvent('DashboardScr_Period_Change');
}

export function clickProfileShareNewLink() {
  analyticsActionEvent('ProfileScr_ButtonShare_ClickedGenerate');
}

export function clickProfileShareCopy() {
  analyticsActionEvent('ProfileScr_ButtonShare_ClickedCopy');
}

export function viewDashboardCharts() {
  analyticsActionEvent('DashboardScr_Viewed_Web');
}

export function viewDashboardMyData() {
  analyticsActionEvent('DashboardScr_MyData_Viewed_Web');
}

export function viewDashboardChartsDeep() {
  analyticsActionEvent('DashboardScr_Scroll_Made');
}

export function viewNewDashboard() {
  const eventProperties = {
    is_demo: 'False',
  };
  analyticsActionEvent('MyData_Viewed', eventProperties);
}

export function viewOldDashboard() {
  analyticsActionEvent('MyData_OldDashboard_Viewed_Web');
}

export function viewDataSourcesFromChart(category) {
  const eventProperties = {
    category: category,
  };
  analyticsActionEvent('Integrations_Viewed_Web', eventProperties);
}

export function clickDashboardExportChart(category, view, primary, secondary) {
  const eventProperties = {
    category: category,
    view: view,
    primary: primary,
    secondary: secondary,
  };
  analyticsActionEvent('Chart_Share_Clicked', eventProperties);
}

export function clickDashboardViewChart(category, view, primary, secondary) {
  const eventProperties = {
    category: category,
    view: view,
    primary: primary,
    secondary: secondary,
  };
  analyticsActionEvent('Chart_Viewed_Web', eventProperties);
}

export function clickDashboardChagePeriodChart(category, view, primary, secondary, flip) {
  const eventProperties = {
    category: category,
    view: view,
    primary: primary,
    secondary: secondary,
    flip: flip,
  };
  analyticsActionEvent('Chart_Flipped_Web', eventProperties);
}

export function viewUserDeleteAccountScreen(screen) {
  const eventProperties = {
    screen: screen
  };
  analyticsActionEvent('Asker_Delete_Account_Viewed', eventProperties);
}


export function clickUserDeleteAccountButton(screen) {
  const eventProperties = {
    screen: screen
  };
  analyticsActionEvent('Asker_Delete_Account_Button_Agree_Clicked', eventProperties);
}

export function clickUserDeleteAccountCancelButton(screen) {
  const eventProperties = {
    screen: screen
  };
  analyticsActionEvent('Asker_Delete_Account_Button_Refused_Clicked', eventProperties);
}

export function viewUserDeleteAccountFinishScreen() {
  analyticsActionEvent('Account_Deleted_Screen_Viewed');
}

export function clickUserDeleteAccountOKButton() {
  analyticsActionEvent('Account_Deleted_Button_Clicked');
}
